import {FacetAccessor, AggsContainer, CardinalityMetric, TermsBucket} from 'searchkit';
import {isEmpty, omitBy, isUndefined} from "lodash"

export function FilterBucket(key, filter, ...childAggs) {
  if (isEmpty(filter)) {
    return AggsContainer(key, {filter: {match_all:{}}}, childAggs)
  }
  return AggsContainer(key, {filter}, childAggs)
}

class CustomFacetAccessor extends FacetAccessor {
  buildOwnQuery(query){
    if (!this.loadAggregations){
      return query
    } else {
      let excludedKey = (this.isOrOperator()) ? this.uuid : undefined
      return query
        .setAggs(FilterBucket(
          this.uuid,
          query.getFiltersWithoutKeys(excludedKey),
          ...this.fieldContext.wrapAggregations(
            TermsBucket(this.key, this.key, omitBy({
              size:this.size,
              order:this.getOrder(),
              include: this.options.include,
              exclude: this.options.exclude,
              min_doc_count:this.options.min_doc_count
            }, isUndefined)),
            CardinalityMetric(this.key+"_count", this.key)
          )
        ))
    }
  }
}

export default CustomFacetAccessor;



// WEBPACK FOOTER //
// ./src/FacetAccessor.js